




























































import {Component, Prop, Watch} from "vue-property-decorator";
import { Action } from "vuex-class";
import { dateFilter } from "@/utils/date-util";
import { CallDetailEventsItem } from "@/store/call/statistic/types";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";

@Component({ filters: {dateFilter} })
export default class CallEventsDetail extends BaseItemsPage<CallDetailEventsItem> {
  @Prop() readonly createDate!: string;
  @Action("getCallDetailEvents") actionGetEvents: any;

  private responseItems: CallDetailEventsItem[] = [];
  currentSort = "date";

  getData() {
    return this.responseItems;
  }

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return ['date', 'name', 'data', 'duration'];
  }

  @Watch('createDate', { immediate: true })
  async onCreateDateChange(val: string) {
    if (val && this.$route.params.id) {
      const resp = await this.actionGetEvents({ id: this.$route.params.id, filter: {} });
      this.responseItems = resp.data.events || [];
    }
  }
}
